// extracted by mini-css-extract-plugin
export default {"card":"SceneHighlightCard_card__96P8E","thumbnail":"SceneHighlightCard_thumbnail__6+xse","text":"SceneHighlightCard_text__M4Av2","highlight":"SceneHighlightCard_highlight__lR975"};